import svgPaths from '../../../assets/imports/PgrmLandingPageLogada/svg-pcvkdvqoas';
import imgVector from '../../../assets/pix_logo.png';
import { useInView } from '../../../hooks/useInView';
import styles from './OpcoesPagamento.module.scss';

function PixCard({ delay }: Readonly<{ delay: number }>) {
  const [ref, inView] = useInView<HTMLDivElement>();
  return (
    <div
      ref={ref}
      className={`${styles.card} ${inView ? 'inView' : ''}`}
      style={{ transitionDelay: `${delay}s` }}
    >
      <div className={`${styles.iconBox} ${styles.pixBox}`}>
        <img alt='' className={styles.pixIcon} src={imgVector} />
      </div>
      <p className={styles.title}>Pix</p>
      <p className={styles.desc}>Pagamento instantâneo 24/7</p>
    </div>
  );
}

function CardWithIcon({
  boxClass,
  fill,
  title,
  description,
  delay,
}: Readonly<{
  boxClass: string;
  fill: string;
  title: string;
  description: string;
  delay: number;
}>) {
  const [ref, inView] = useInView<HTMLDivElement>();
  return (
    <div
      ref={ref}
      className={`${styles.card} ${inView ? 'inView' : ''}`}
      style={{ transitionDelay: `${delay}s` }}
    >
      <div className={`${styles.iconBox} ${boxClass}`}>
        <svg
          className={styles.svgIcon}
          fill='none'
          height='56'
          viewBox='0 0 56 56'
          width='56'
        >
          <path d={svgPaths.p35ed1400} fill={fill} />
        </svg>
      </div>
      <p className={styles.title}>{title}</p>
      <p className={styles.desc}>{description}</p>
    </div>
  );
}

export function OpcoesPagamento() {
  return (
    <div className={styles.section} data-name='opcoes-pagamento'>
      <div className={styles.heading}>
        <p className={styles.sectionTitle}>
          Arrecadação agora com mais opções de pagamento:
        </p>
        <p className={styles.sectionSub}>
          Integração com o PagTesouro para facilitar sua vida.
        </p>
      </div>
      <div className={styles.cards}>
        <PixCard delay={0} />
        <div className={styles.divider} />
        <CardWithIcon
          boxClass={styles.debitBox}
          fill='#109AB9'
          title='Cartão de Débito'
          description='Mais praticidade no pagamento'
          delay={0.12}
        />
        <div className={styles.divider} />
        <CardWithIcon
          boxClass={styles.creditBox}
          fill='#8B5CF6'
          title='Cartão de Crédito'
          description='Parcele com segurança e comodidade'
          delay={0.24}
        />
      </div>
    </div>
  );
}
